import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RouterExtService } from '../../services/router-ext.service';
import { ReadableSsoError, SsoErrorType } from './enums/sso-error-type.enum';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnumExt } from '../../services/enum-ext';

@Component({
    selector: 'app-sso-error',
    templateUrl: './sso-error.component.html',
    styleUrls: ['./sso-error.component.scss'],
    standalone: false,
})
export class SsoErrorComponent {
    protected readonly ReadableSsoError = ReadableSsoError;

    protected error$: Observable<{ errorCode: SsoErrorType; message: string }> = this.route.queryParams.pipe(
        map((params) => {
            const errorCodeInt = parseInt(params['errorCode'], 10);

            const errorCode: SsoErrorType = EnumExt.IsEnum(errorCodeInt, SsoErrorType)
                ? (errorCodeInt as SsoErrorType)
                : SsoErrorType.UnexpectedError;

            const message = decodeURI(params['message'] ?? params['error_description'] ?? '');

            return { errorCode, message };
        }),
    );

    constructor(private router: Router, private route: ActivatedRoute, private routerExt: RouterExtService) {}

    public backHandler(): void {
        const previousUrl = this.routerExt.getPreviousUrl() || '/';
        this.router.navigateByUrl(previousUrl).catch(console.error);
    }
}
